<template>
  <v-chip color="grey lighten-3" close @click:close="removeFilter">
    <v-avatar>
      <v-progress-circular
        :rotate="-90"
        :size="28"
        :width="2"
        :value="progressValue"
        :color="progressColour"
        v-if="iconType === 'progress'"
      >
        {{ progressValue }}
      </v-progress-circular>
      <img v-if="iconType === 'image'" :src="iconValue" alt="" />
      <v-icon v-if="iconType === 'icon'" color="grey" style="font-size: 20px">{{ iconValue }}</v-icon>
    </v-avatar>
    <strong>{{ label }}</strong>
  </v-chip>
</template>
<script>
export default {
  name: 'AbfFilterChip',
  props: ['label', 'icon-value'],
  computed: {
    iconType() {
      if (this.iconValue.startsWith('progress_')) {
        return 'progress';
      }
      if (this.iconValue.startsWith('http')) {
        return 'image';
      }
      return 'icon';
    },
    progressColour() {
      return this.iconValue === 'progress_full' ? 'accent' : 'grey';
    },
    progressValue() {
      return this.iconValue === 'progress_full' ? 100 : 0;
    }
  },
  methods: {
    removeFilter() {
      this.$emit('remove');
    }
  }
};
</script>

<style lang="scss" scoped>
div.input-group {
  padding-top: 0;
}
::v-deep .input-group__details {
  display: none;
}
</style>
